import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseCoreState, baseInquiryActions, baseInquirySelectors } from '../../../_store';

@Injectable({ providedIn: 'root' })
export class BaseInquiryCandidatesGuard {
  constructor(private readonly store: Store<BaseCoreState>) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    this.store.dispatch(
      baseInquiryActions.loadInquiryCandidatesList({
        payload: {
          ...route.queryParams,
          inquiry: +route.parent?.params.inquiry,
        },
      })
    );
    return this.store.select(baseInquirySelectors.getInquiryCandidates).pipe(
      filter((response) => response.ok !== undefined),
      map((response) => !!response.ok)
    );
  }
}
